import { baseApi } from "./baseApi";

/**
 * Lock Desk status configuration (pro-api#128).
 * Normalizes the response so consumers always read { isEnabled, reason, updatedAt, updatedBy } —
 * tolerant of field-name drift while the backend contract is finalized.
 */
export const normalizeLockDeskStatus = (raw) => {
  // Fail open: if the endpoint is missing or returns nothing, locking behaves as before.
  if (raw == null) return { isEnabled: true, reason: null, updatedAt: null, updatedBy: null };
  if (typeof raw === "boolean") return { isEnabled: raw, reason: null, updatedAt: null, updatedBy: null };
  return {
    isEnabled: (raw.isEnabled ?? raw.enabled ?? raw.lockDeskEnabled ?? raw.isLockDeskEnabled) !== false,
    reason: raw.reason ?? raw.message ?? null,
    updatedAt: raw.updatedAt ?? raw.lastUpdatedAt ?? null,
    updatedBy: raw.updatedBy ?? raw.lastUpdatedBy ?? null,
  };
};

const lockDeskApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLockDeskStatus: builder.query({
      query: () => ({
        url: "/configuration/lock-desk",
        method: "GET",
      }),
      transformResponse: normalizeLockDeskStatus,
      providesTags: ["LockDesk"],
    }),

    updateLockDeskStatus: builder.mutation({
      query: (body) => ({
        url: "/configuration/lock-desk",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["LockDesk"],
    }),
  }),
});

export default lockDeskApi;
